module.exports = __webpack_public_path__ + "img/member2.2bd77a85.png";